export default __webpack_public_path__ + "static/media/32.7069c17f.mp3";